function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.005,10.239H43.877l-9.36-9.36C33.954,0.316,33.19,0,32.395,0H3C1.343,0,0,1.343,0,3v9.533 c0,0.121,0.021,0.236,0.035,0.354C0.021,13.004,0,13.118,0,13.239v56.404c0,1.657,1.343,3,3,3h87.005c1.656,0,3-1.343,3-3V13.239 C93.005,11.582,91.662,10.239,90.005,10.239 M31.152,6l4.24,4.239H6V6H31.152z M87.005,66.644H6V16.239h81.005V66.644z"
});

var SvgCartella = function SvgCartella(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 94,
    height: 74,
    viewBox: "-0.565 -0.924 94 74",
    enableBackground: "new -0.565 -0.924 94 74",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCartella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cartella.17129836.svg";
export { ForwardRef as ReactComponent };